import React from 'react';
import { Danger } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/components/errorBoxStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IErrorBoxProps {
	text: string | React.ReactElement;
}

const ErrorBox = ({ text }: IErrorBoxProps) => {
	const classes = useStyles();
	return (
		<div className={classes.boxWrapper}>
			<Danger>{text}</Danger>
		</div>
	);
};

export default ErrorBox;
